<template>
    <div :key="formKey" v-if="getScreenWidth > 425 && user">
        <va-page-header>

            <div slot="title">

                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>

                <span v-if="viewedForm == null">{{ _('Form') }}</span>
                <span v-else class="edit_title" @click="showFormEditLabelModal">{{ g_getLabel(viewedForm) }}
                    <va-icon v-if="viewedForm != null" style="zoom: 0.9; margin-left: 10px" color="#999"
                        type="pencil-alt"></va-icon>
                </span>

                <span class='status' v-if="viewedForm == null">{{ _('Draft') }}</span>
                <span class='status' v-else>{{
                    _(viewedForm.get('survey_design_status')) }}</span>

            </div>
            <div slot="actions" style="display: flex; flex-direction: row; align-items:  center">
                <va-checkbox-group v-if="section != 'survey'" v-model="formLanguages" style="margin-right: 10px">
                    <va-checkbox label="english" checked>English</va-checkbox>
                    <va-checkbox label="pashto">پښتو</va-checkbox>
                    <va-checkbox label="dari">دری</va-checkbox>
                </va-checkbox-group>
                <va-button
                    v-if="section == 'survey' && viewedForm && viewedForm.get('survey_design_status') == 'pending' && (user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(viewedForm)) || (user.get('roles').includes('survey-approver') && g_isFormDesignApprover(viewedForm)) || (user.get('roles').includes('survey-editor') && g_isFormDesignApprover(viewedForm)))"
                    size="lg" type="danger" @click.native="rejectObject">
                    {{ _('REJECT') }}
                </va-button>
                <va-button
                    v-if="section == 'survey' && viewedForm && viewedForm.get('survey_design_status') == 'pending' && (user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(viewedForm)) || (user.get('roles').includes('survey-approver') && g_isFormDesignApprover(viewedForm)) || (user.get('roles').includes('survey-editor') && g_isFormDesignApprover(viewedForm)))"
                    size="lg" style="margin-right: 10px" type="info" @click.native="approveObject">
                    {{ _('APPROVE') }}
                </va-button>

                <va-button v-if="section == 'survey' && viewedForm" :class="{no_click: loading}"
                    @click.native="$router.push('/surveys/' + $route.params.id)" type="paleblue" size="lg"
                    style="margin-right: 10px">{{_("PREVIEW")}}
                </va-button>

                <va-button
                    v-if="viewedForm && viewedForm.get('survey_design_status') != 'rejected' && (user.get('roles').includes('admin') || (user.get('roles').includes('manager') && g_canEditForm(viewedForm)) || ((user.get('roles').includes('survey-editor') || user.get('roles').includes('survey-approver')) && g_isFormDesignApprover(viewedForm)))"
                    size="lg" :class="{no_click: loading}" type="primary" @click.native="updateForm">
                    {{ _('UPDATE') }}
                </va-button>
                <va-button
                    v-else-if="!viewedForm && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor'))"
                    :class="{no_click: loading}" size="lg" type="primary" @click.native="showFormLabelsModal">
                    <span>{{ _('CREATE') }}</span>
                </va-button>
            </div>

        </va-page-header>

        <va-modal :title="getSavingFormModalTile" width="900px" ref="formLabelsModal" backdrop-clickable
            @confirm="createForm">
            <div slot="body">
                <div style="display: flex; justify-content: space-between">
                    <va-input v-model="formEnglishLabel" @keyup.native.enter="createForm" showClean
                        :placeholder="_('English name')"></va-input>
                    <va-input v-model="formPashtoLabel" @keyup.native.enter="createForm" showClean
                        :placeholder="_('Pashto name')"></va-input>
                    <va-input v-model="formDariLabel" @keyup.native.enter="createForm" showClean
                        :placeholder="_('Dari name')"></va-input>
                </div>
            </div>
        </va-modal>

        <div v-if="section != 'survey'">
            <form-builder :viewedForm="viewedForm" v-bind:selectedFields.sync="formFields"
                v-bind:formLanguages="formLanguages" :viewedFormLayout="viewedFormLayout" />
        </div>
        <div v-else>
            <va-row>
                <va-column :lg="12" :md="12" :sm="12" :xs="12">

                    <va-tabs :cache-lifetime="10" style="min-height:680px !important;">
                        <va-tab :name="_('Design Survey')">
                            <form-builder style="padding-bottom: 90px" :key="form_key" :viewedForm="viewedForm"
                                v-bind:selectedFields.sync="formFields" v-bind:formLanguages.sync="formLanguages"
                                :viewedFormLayout="viewedFormLayout" />
                        </va-tab>

                        <va-tab :name="_('Settings')">
                            <div style="padding: 20px 0 0 0 ">
                                <va-form type="vertical" ref="form">

                                    <va-row>

                                        <va-column :lg="12" :md="12" :sm="12" :xs="12">
                                            <va-row :gutter="12">

                                                <!-- Language -->
                                                <va-column :lg="6" :md="6" :sm="6" :xs="6">
                                                    <div style="padding-right: 10px">
                                                        <p class="field_label">{{_('Survey Languages')}}</p>
                                                        <va-checkbox-group v-model="formLanguages"
                                                            style="margin-right: 10px">
                                                            <va-checkbox label="english" checked>English</va-checkbox>
                                                            <va-checkbox label="pashto">پښتو</va-checkbox>
                                                            <va-checkbox label="dari">دری</va-checkbox>
                                                        </va-checkbox-group>
                                                    </div>
                                                </va-column>

                                                <!-- Province -->
                                                <va-column :lg="6" :md="6" :sm="6" :xs="6">
                                                    <div style="padding-right: 10px">
                                                        <p class="field_label">{{_('Province')}}</p>
                                                        <va-select :show-selected="false" :options="getProvinces"
                                                            v-model="selectedProvinces" :placeholder="_('Province')"
                                                            :no-uncheck="true" multiple>
                                                        </va-select>
                                                    </div>
                                                </va-column>
                                            </va-row>

                                        </va-column>

                                        <!-- ASSIGNMENT COLUMN -->
                                        <va-column :lg="12" :md="12" :sm="12" :xs="12" class="assignment_col">
                                            <va-form type="vertical" ref="form" style="margin-top: 25px">

                                                <va-row :gutter="12">

                                                    <!-- assignees -->
                                                    <va-column :lg="4" :md="4" :sm="4" :xs="12">
                                                        <va-card :elevation="2" :padding="10" style="padding: 10px">
                                                            <user-selection v-bind:selected.sync="submitters"
                                                                :showRequired="false" :title="_('Submitter')"
                                                                :roles="getSubmitterRoles"
                                                                :disable="getDecisionForSubmisison"
                                                                :department="department" />
                                                        </va-card>
                                                    </va-column>

                                                    <!-- submission approver -->
                                                    <va-column :lg="4" :md="4" :sm="4" :xs="12">
                                                        <va-card :elevation="2" :padding="10" style="padding: 10px">
                                                            <user-selection v-bind:selected.sync="submissionApprovers"
                                                                v-bind:isAssigningUser.sync="isAssigningSubmissionApprovers"
                                                                :showRequired="true" :title="_('Submission Approver')"
                                                                :roles="getSubmissionRoles"
                                                                :disable="getDecisionForSubmisison"
                                                                :department="department" />
                                                        </va-card>
                                                    </va-column>

                                                    <!-- design approver -->
                                                    <va-column :lg="4" :md="4" :sm="4" :xs="12">
                                                        <va-card :elevation="2" :padding="10" style="padding: 10px">
                                                            <user-selection v-bind:selected.sync="designApprovers"
                                                                v-bind:isAssigningUser.sync="isAssigningDesignApprovers"
                                                                :showRequired="true"
                                                                :title="_('Survey Design Approver')"
                                                                :roles="getDesignRoles" :disable="getDecisionForDesign"
                                                                :department="department" />
                                                        </va-card>
                                                    </va-column>

                                                </va-row>

                                                <va-row :gutter="12">

                                                    <!-- sharing with guest-->
                                                    <va-column :lg="4" :md="4" :sm="4" :xs="12">
                                                        <va-card :elevation="2" :padding="10" style="padding: 10px">
                                                            <user-selection v-bind:selected.sync="sharedWith"
                                                                :showRequired="false" :title="_('Share With Guests')"
                                                                :roles="['guest']" :disable="false" />
                                                        </va-card>
                                                    </va-column>

                                                </va-row>
                                            </va-form>
                                        </va-column>
                                    </va-row>

                                </va-form>

                                <va-row v-if="viewedForm && user.get('type') != 'guest'">
                                    <va-column :lg="12" :md="12" :sm="12" :xs="12">
                                        <activities />
                                    </va-column>
                                </va-row>
                            </div>
                        </va-tab>

                    </va-tabs>

                </va-column>
            </va-row>
        </div>

    </div>
    <div v-else style="height: 100%;display: flex; justify-content: center; align-items: center">
        <p style="    background: gray;
        color: beige;
        text-transform: uppercase;
        text-align: center;">{{ _('Survey design is not avaible for small screens') }}</p>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapActions, mapGetters } from 'vuex'
    import FormBuilder from "./FormBuilder.vue"
    import UserSelection from "./UserSelection.vue"
    import Activities from "./Activities.vue"

    export default {
        components: {
            FormBuilder,
            UserSelection,
            Activities
        },

        data() {
            return {
                formEnglishLabel: '',
                formPashtoLabel: '',
                formDariLabel: '',
                viewedForm: null,
                viewedFormLayout: [],
                formLanguages: ['english'],
                isEditingLabels: false,
                formKey: '',
                section: '',
                formFields: [],

                // survey
                provinces_english: [],
                provinces_pashto: [],
                selectedProvinces: [],
                submitters: [],
                submissionApprovers: [],
                designApprovers: [],
                allProvinces: [],
                isAssigningSubmissionApprovers: false,
                isAssigningDesignApprovers: false,

                sharedWith: [],

                // category
                category: null,
                department: null,

                form_key: '',
            }
        },

        computed: {
            ...mapGetters(['loading', 'user', 'getCurrentCategory', 'getCurrentDepartment', 'getAllProvincesFromState']),

            isUserSurveyApprover() {
                var isSurveyApprover = false;
                if (this.viewedForm != null && this.viewedForm.get('survey_design_approvers') != null) {
                    for (let i = 0; i < this.viewedForm.get('survey_design_approvers').length; i++) {
                        const approver = this.viewedForm.get('survey_design_approvers')[i];
                        if (approver != null && this.user != null && approver.id == this.user.id) {
                            isSurveyApprover = true;
                            break
                        }
                    }
                }
                return isSurveyApprover;
            },

            getSection() {
                if (this.$route.matched && this.$route.matched.length > 0) return this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
                return ''
            },

            getCategory() {
                return this.category || this.getCurrentCategory
            },

            getSavingFormModalTile() {
                if (this.$route.matched[0].name == 'surveys') {
                    return this._('Survey Form')
                } else {
                    return this._(this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1) + ' meta form')
                }
            },

            getScreenWidth() {
                if (window != null && window.screen != null && window.screen.width != null) {
                    return window.screen.width;
                }
                return 426
            },

            getDecisionForDesign() {
                if (this.viewedForm) {
                    if (this.viewedForm.get('survey_design_status') == 'pending')
                        return false
                    else if (this.viewedForm.get('survey_design_status') == 'approved' || this.viewedForm.get('survey_design_status') == 'rejected')
                        return true
                }
                else return false
            },

            getDecisionForSubmisison() {
                if (this.viewedForm) {
                    if (this.viewedForm.get('status') == 'completed')
                        return true
                    else
                        return false
                } else return false
            },

            getSubmitterRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes('survey-editor')) {
                    return ['submitter', 'survey-editor', 'manager']
                } else if (this.user.get('roles').includes('admin')) return ['admin', 'manager', 'submitter', 'survey-editor']
            },

            getSubmissionRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes('survey-editor')) {
                    return ['submission-approver', 'survey-editor', 'manager']
                } else if (this.user.get('roles').includes('admin')) return ['admin', 'manager', 'submission-approver', 'survey-editor']
            },

            getDesignRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes('survey-editor')) {
                    return ['survey-approver', 'manager', 'survey-editor']
                } else if (this.user.get('roles').includes('admin')) return ['admin', 'manager', 'survey-approver', 'survey-editor']
            },

            getProvinces() {
                if (this.getSystemLanguage == 'dari' || this.getSystemLanguage == 'pashto') {
                    if (this.provinces_pashto.length != 0) {
                        this.selectedProvinces = [this.provinces_pashto[0].value]
                        return this.provinces_pashto
                    }
                }
                else {
                    if (this.provinces_english.length != 0) {
                        this.selectedProvinces = [this.provinces_english[0].value]
                        return this.provinces_english
                    }
                }
            },

            getSelectedProvincesObject() {
                let selected = []
                this.selectedProvinces.forEach(provinceId => {
                    this.allProvinces.forEach(province => {
                        if (provinceId == province.id) selected.push(province)
                    })
                })

                return selected
            }
        },

        watch: {
            formLanguages: function (val) {
                if (val.length == 0) {
                    this.formLanguages = ['english']
                }
            },

            async '$route'(v) {
                await this.fetchings()
            }
        },

        methods: {
            ...mapActions(['setAllProvincesToState', 'setCurrentFormToState']),

            // approved
            approveObject() {
                this.g_approveObject(this.viewedForm)
                    .then(async result => {
                        this.viewedForm = result
                        this.articleKey = Date.now()

                    }).catch(e => {

                    })
            },

            rejectObject() {
                this.g_rejectObject(this.viewedForm)
                    .then(result => {
                        this.viewedForm = result
                        this.articleKey = Date.now()
                    }).catch(e => {

                    })
            },

            showFormEditLabelModal() {
                this.isEditingLabels = true
                this.$refs.formLabelsModal.open()
            },

            showFormLabelsModal() {
                if (this.$route.params.id != 'new') this.updateForm()
                else {
                    this.$refs.formLabelsModal.open()
                }
            },

            async updateFormLabels() {
                if (this.viewedForm && this.viewedForm.get('survey_design_status') != 'rejected' && (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager') || this.user.get('roles').includes('survey-editor') || (this.user.get('roles').includes('survey-approver') && this.isUserSurveyApprover))) {
                    // check for duplicate database name, conider without the current form(objectId)
                    let className = ''
                    if (this.getSection == 'survey')
                        className = 'Data_' + this.formEnglishLabel.slugify()
                    else className = 'Meta_' + this.formEnglishLabel.slugify()

                    let q = new Parse.Query('Form')
                    q.equalTo('class_name', className)
                    q.notEqualTo('objectId', this.viewedForm.id)
                    let result = await q.first()


                    if (!result) {
                        var prevEnglishLabel = this.viewedForm.get('label_english')
                        var prevPashtoLabel = this.viewedForm.get('label_pashto')
                        var prevDariLabel = this.viewedForm.get('label_dari')

                        this.viewedForm.set('label_english', this.formEnglishLabel)
                        this.viewedForm.set('label_pashto', this.formPashtoLabel)
                        this.viewedForm.set('label_dari', this.formDariLabel)
                        this.viewedForm.save().then(async res => {
                            await this.g_newActivity({
                                label_english: res.get('label_english'),
                                label_pashto: res.get('label_pashto'),
                                label_dari: res.get('label_dari'),
                                previous_label_english: prevEnglishLabel,
                                previous_label_pashto: prevPashtoLabel,
                                previous_label_dari: prevDariLabel,
                                type: 'survey',
                                action: 'editLabel',
                                url: this.$route.path,
                                to: null,
                                category: this.getCategory,
                                department: this.department,
                                class: 'Form',
                                reference_id: res.id
                            })
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('Form labels were updated'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                        }).catch(e => {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('An error accured while editing form labels'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        })
                    } else {
                        this.$store.commit('setLoading', false)
                        this.$notify({
                            group: 'foo',
                            text: this._('A form already exists with the same name'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });
                    }
                } else {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Permission denied'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                }
            },

            async updateForm() {
                if (this.viewedForm && this.viewedForm.get('survey_design_status') != 'rejected' && (this.user.get('roles').includes('admin') || this.user.get('roles').includes('manager') || this.user.get('roles').includes('survey-editor') || (this.user.get('roles').includes('survey-approver') && this.isUserSurveyApprover))) {
                    if (this.viewedForm && this.viewedForm.get('status') == 'completed') {
                        // while survey is completed, then only guest list can be updated
                        await this.showConfirmMessageForUpdatingForm('By updating this completed form, only guest list would be updated', 'completed')
                    } else {
                        if (this.formFields.length == 0) {
                            this.$notify({
                                group: 'foo',
                                text: this._('At least one field is required to update form'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                            return false
                        } else if (this.getSection == 'survey' && this.selectedProvinces.length == 0) {
                            this.$notify({
                                group: 'foo',
                                text: this._('Please select province'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            });
                            return false
                        } else {
                            for (const index in this.formFields) {
                                let field = this.formFields[index]

                                let checkDupsResult = this.checkDuplicateFieldsWithSameDatabaseNames(field)
                                if (checkDupsResult.length != 0) {
                                    this.showErrorMessage('Duplicate field database name of type ' + checkDupsResult[0].type.toUpperCase() + ' was detected')
                                    this.$store.commit('setLoading', false)
                                    return false;
                                }

                                if ((this.formLanguages.includes('english') && !field.englishLabel) || (this.formLanguages.includes('pashto') && !field.pashtoLabel) || (this.formLanguages.includes('dari') && !field.dariLabel)) {
                                    this.showErrorMessage('Empty fields were detected in form design')
                                    this.$store.commit('setLoading', false)
                                    return false;
                                }


                                if (field.type == 'multiple-option' || field.type == 'single-option' || field.type == 'select') {
                                    if (!this.formLanguages.includes(field.optionValueInDatabase)) {
                                        this.showErrorMessage('Option value langauge was not found in selected languages, please open each multi-choise fields and select a language')
                                        this.$store.commit('setLoading', false)
                                        return false;
                                    }

                                    if (field.options.length == 0) {
                                        this.showErrorMessage('One of multi-choise fields does not have any options, please list some')
                                        this.$store.commit('setLoading', false)
                                        return false;
                                    }

                                    for (const key in field.options) {
                                        if ((this.formLanguages.includes('english') && (!field.options[key].englishLabel || !field.options[key].value)) || (this.formLanguages.includes('pashto') && (!field.options[key].pashtoLabel || !field.options[key].value)) || (this.formLanguages.includes('dari') && (!field.options[key].dariLabel || !field.options[key].value))) {
                                            this.showErrorMessage('Empty option labels were detected')
                                            this.$store.commit('setLoading', false)
                                            return false;
                                        }
                                    }
                                }
                            }

                            if (this.getSection == 'survey' && ((this.isAssigningDesignApprovers && this.designApprovers.length == 0) || (this.isAssigningSubmissionApprovers && this.submissionApprovers.length == 0))) {
                                this.showErrorMessage('Require approval is checked')
                                this.$store.commit('setLoading', false)
                                return false;
                            }

                            if (this.viewedForm && this.viewedForm.get('status') != 'pending') {
                                await this.showConfirmMessageForUpdatingForm('Are you sure you want to update this survey. because the database schema will be changed.', this.viewedForm.get('status'))
                            } else {
                                this.$store.commit('setLoading', true)
                                await this.upateFormAfterValidation(this.viewedForm)
                            }
                        }
                    }
                }
            },

            async showConfirmMessageForUpdatingForm(message, form_status) {
                var self = this
                this.VaModal.confirm({
                    title: 'Wait...',
                    message: this._(message),
                    type: 'danger',
                    async onConfirm() {
                        self.$store.commit('setLoading', true)
                        if (form_status == 'completed') {
                            await self.updateFormGuestList()
                        } else {
                            await self.upateFormAfterValidation()
                        }
                    }
                })
            },

            async updateFormGuestList() {
                var guests = this.sharedWith.map(guest => guest.user)
                this.viewedForm.set('shared_with', guests)
                await this.viewedForm.save().then(async updatedForm => {
                    this.viewedForm = updatedForm
                    var temp = [...this.sharedWith]
                    if (temp) {
                        for (let i = 0; i < temp.length; i++) {
                            const guest = temp[i];
                            if (!guest.isPrev) {
                                await this.createActivity(updatedForm, 'shareWithGuest', guest.user)
                            }
                            temp[i]['isPrev'] = true
                        }
                        this.sharedWith = [...temp]
                    }
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Form guest list was updated'),
                        duration: 4000,
                        position: 'top left',
                        type: 'success'
                    });
                }).catch(e => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        title: this._('System Error'),
                        text: this._('Error accured while updating guest list'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                })
            },

            async upateFormAfterValidation() {
                var old_languages = [...this.viewedForm.get('form_languages')]
                var old_layout = [...this.viewedForm.get('layout')]

                if (this.getSection == 'survey') {
                    var old_survey_submitters = [...this.viewedForm.get('survey_submitters')]
                    var old_survey_submission_approvers = [...this.viewedForm.get('survey_submission_approvers')]
                    var old_survey_design_approvers = [...this.viewedForm.get('survey_design_approvers')]
                    var old_shared_with = [...this.viewedForm.get('shared_with')]
                }

                this.viewedForm.set('layout', this.formFields)
                this.viewedForm.set('form_languages', this.formLanguages)
                if (this.getSection == 'survey') {
                    this.viewedForm.set('survey_provinces', this.getSelectedProvincesObject)
                    this.viewedForm.set('survey_submitters', this.submitters.map(user => user.user))
                    this.viewedForm.set('survey_submission_approvers', this.submissionApprovers.map(user => user.user))
                    this.viewedForm.set('survey_design_approvers', this.designApprovers.map(user => user.user))
                    if (this.viewedForm.get('survey_design_status') == 'pending') this.viewedForm.set('survey_design_status', this.isAssigningDesignApprovers ? 'pending' : 'approved')
                    this.viewedForm.set('submission_require_approval', this.isAssigningSubmissionApprovers)
                    this.viewedForm.set('design_require_approval', this.isAssigningDesignApprovers)
                    this.viewedForm.set('shared_with', this.sharedWith.map(guest => guest.user))
                }
                this.viewedForm.save().then(async updatedForm => {
                    this.viewedForm = updatedForm
                    if (updatedForm && updatedForm.get('status') != 'pending') {
                        // await this.updateThisSurveysSubmissionsClassFields(updatedForm)
                        await this.publisher(updatedForm, updatedForm.get('is_meta_form'))
                    }
                    await this.updateActivities(updatedForm, old_languages, old_layout, old_survey_submitters, old_survey_submission_approvers, old_survey_design_approvers, old_shared_with)
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        text: this._('Form was updated'),
                        duration: 4000,
                        position: 'top left',
                        type: 'success'
                    });
                }).catch(e => {
                    this.$store.commit('setLoading', false)
                    this.$notify({
                        group: 'foo',
                        title: this._('System Error'),
                        text: this._('An error was encountered while updating ' + this.getSection + ' form'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                })
            },

            // async updateThisSurveysSubmissionsClassFields(form) {
            //     var NewClass = Parse.Object.extend(form.get('class_name'));
            //     var newEntry = new NewClass();
            //     let myObject = {}

            //     form.get('layout').forEach(field => {
            //         if (!field.isPrevious) {
            //             if (field.type !== 'heading' && field.type !== 'description') {
            //                 if (field.type == 'text') {
            //                     if (field.fieldType == 'number') {
            //                         myObject[field.fieldDatabaseName] = 0
            //                     } else {
            //                         myObject[field.fieldDatabaseName] = ''
            //                     }
            //                 } if (field.type == 'textarea' || field.type == 'single-option') {
            //                     myObject[field.fieldDatabaseName] = ''
            //                 } else if (field.type == 'checkbox') {
            //                     myObject[field.fieldDatabaseName] = false
            //                 } else if (field.type == 'select' || field.type == 'attachment') {
            //                     if (field.multiple)
            //                         myObject[field.fieldDatabaseName] = []
            //                     else myObject[field.fieldDatabaseName] = ''
            //                 } else if (field.type == 'date') {
            //                     myObject[field.fieldDatabaseName] = new Date()
            //                 } else if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
            //                     myObject[field.fieldDatabaseName] = []
            //                 } else if (field.type == 'single-geolocation') {
            //                     myObject['latitude'] = 0;
            //                     myObject['longitude'] = 0;
            //                 }
            //             }
            //         }
            //     })

            //     await newEntry.save(myObject).then(async item => {
            //         item.destroy()
            //             .then(async r => {

            //             }).catch(e => {

            //             })
            //     }).catch(theError => {

            //     })
            // },

            async updateActivities(updatedForm, old_languages, old_layout, old_survey_submitters, old_survey_submission_approvers, old_survey_design_approvers, old_shared_with) {
                // itself
                await this.createActivity(updatedForm, 'edit', null)

                // layout
                if (old_layout.length != this.formFields.length) {
                    var action = old_layout.length < this.formFields.length ? 'addFields' : 'removeFields'
                    await this.createActivity(updatedForm, action, null)
                }

                // language
                if (old_languages.length != this.formLanguages.length) {
                    var action = old_languages.length < this.formLanguages.length ? 'addLanguage' : 'removeLanguage'
                    await this.createActivity(updatedForm, action, null)
                }

                if (this.getSection == 'survey') {
                    // submitters
                    if (old_survey_submitters.length != this.submitters.length) {
                        var action = old_survey_submitters.length < this.submitters.length ? 'addSubmitter' : 'removeSubmitter'
                        await this.createActivity(updatedForm, action, null)
                    }
                    if (this.submitters && updatedForm.get('status') != 'pending') {
                        let submitters_temp = [...this.submitters]
                        if (submitters_temp) {
                            for (let i = 0; i < submitters_temp.length; i++) {
                                const user = submitters_temp[i];
                                if (!user.isPrev) {
                                    await this.createActivity(updatedForm, 'submitterAssignment', user.user)
                                }
                                submitters_temp[i]['isPrev'] = true
                            }
                            this.submitters = [...submitters_temp]
                        }
                    }

                    // submission approvers
                    if (old_survey_submission_approvers.length != this.submissionApprovers.length) {
                        var action = old_survey_submission_approvers.length < this.submissionApprovers.length ? 'addSubmissionApprover' : 'removeSubmissionApprover'
                        await this.createActivity(updatedForm, action, null)
                    }
                    if (this.submissionApprovers && updatedForm.get('status') != 'pending') {
                        let submission_approvers_temp = [...this.submissionApprovers]
                        if (submission_approvers_temp) {
                            for (let i = 0; i < submission_approvers_temp.length; i++) {
                                const user = submission_approvers_temp[i];
                                if (!user.isPrev) {
                                    await this.createActivity(updatedForm, 'approvalAssignment', user.user)
                                }
                                submission_approvers_temp[i]['isPrev'] = true
                            }
                            this.submissionApprovers = [...submission_approvers_temp]
                        }
                    }

                    // design approvers
                    if (old_survey_design_approvers.length != this.designApprovers.length) {
                        var action = old_survey_design_approvers.length < this.designApprovers.length ? 'addSurveyDesignApprover' : 'removeSurveyDesignApprover'
                        await this.createActivity(updatedForm, action, null)
                    }
                    if (this.designApprovers && updatedForm.get('status') == 'pending') {
                        let design_approvers_temp = [...this.designApprovers]
                        if (design_approvers_temp) {
                            for (let i = 0; i < design_approvers_temp.length; i++) {
                                const user = design_approvers_temp[i];
                                if (!user.isPrev) {
                                    await this.createActivity(updatedForm, 'designApprovalAssignment', user.user)
                                }
                                design_approvers_temp[i]['isPrev'] = true
                            }
                            this.designApprovers = [...design_approvers_temp]
                        }
                    }

                    // guest
                    if (old_shared_with.length != this.sharedWith.length) {
                        var action = old_shared_with.length < this.sharedWith.length ? 'addGuest' : 'removeGuest'
                        await this.createActivity(updatedForm, action, null)
                    }
                    if (this.sharedWith && updatedForm.get('status') != 'pending') {
                        let guests_temp = [...this.sharedWith]
                        if (guests_temp) {
                            for (let i = 0; i < guests_temp.length; i++) {
                                const user = guests_temp[i];
                                if (!user.isPrev) {
                                    await this.createActivity(updatedForm, 'shareWithGuest', user.user)
                                }
                                guests_temp[i]['isPrev'] = true
                            }
                            this.sharedWith = [...guests_temp]
                        }
                    }

                    if (updatedForm.get('survey_provinces').length != this.selectedProvinces.length) {
                        await this.createActivity(updatedForm, 'editFormProvince', null)
                    }
                }

            },

            async createActivity(form, action, to) {
                await this.g_newActivity({
                    label_english: form.get('label_english'),
                    label_pashto: form.get('label_pashto'),
                    label_dari: form.get('label_dari'),
                    type: this.getSection,
                    action: action,
                    url: this.$route.path,
                    to: to,
                    category: this.getCategory,
                    department: this.department,
                    class: 'Form',
                    reference_id: form.id
                })
            },

            async createForm() {
                if (this.formEnglishLabel == '') {
                    this.VaToast({
                        text: 'English name is required',
                        type: 'danger',
                        placement: 'center',
                        duration: 1000,
                        closeOnClick: false
                    })
                    return false

                } else if (this.formFields.length == 0) {
                    this.$refs.formLabelsModal.close()
                    this.$notify({
                        group: 'foo',
                        text: this._('Atleast one field is required to create form'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                    return false
                } else if (this.getSection == 'survey' && this.selectedProvinces.length == 0) {
                    this.$refs.formLabelsModal.close()
                    this.$notify({
                        group: 'foo',
                        text: this._('Please select province'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    });
                    return false
                } else {
                    this.$refs.formLabelsModal.close()

                    this.$store.commit('setLoading', true)

                    for (const index in this.formFields) {
                        let field = this.formFields[index]

                        let checkDupsResult = this.checkDuplicateFieldsWithSameDatabaseNames(field)
                        if (checkDupsResult.length != 0) {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('Duplicate field database name of type ' + checkDupsResult[0].type.toUpperCase() + ' was detected'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                            return false
                        }



                        if ((this.formLanguages.includes('english') && field.englishLabel == '') || (this.formLanguages.includes('pashto') && field.pashtoLabel == '') || (this.formLanguages.includes('dari') && field.dariLabel == '')) {
                            this.showErrorMessage('Empty fields were detected in form design')
                            this.$store.commit('setLoading', false)
                            return false;
                        }


                        if (field.type == 'multiple-option' || field.type == 'single-option' || field.type == 'select') {

                            if (!this.formLanguages.includes(field.optionValueInDatabase)) {
                                this.showErrorMessage('Option value langauge was not found in selected languages, please open each multi-choise fields and confirm a language')
                                this.$store.commit('setLoading', false)
                                return false;
                            }
                            for (const key in field.options) {
                                if ((this.formLanguages.includes('english') && field.options[key].englishLabel == '') || (this.formLanguages.includes('pashto') && field.options[key].pashtoLabel == '') || (this.formLanguages.includes('dari') && field.options[key].dariLabel == '')) {
                                    this.showErrorMessage('Empty option labels were detected in form design')
                                    this.$store.commit('setLoading', false)
                                    return false;
                                }
                            }
                        }
                    }

                    if (this.getSection == 'survey' && (this.isAssigningDesignApprovers && this.designApprovers.length == 0) || (this.isAssigningSubmissionApprovers && this.submissionApprovers.length == 0)) {
                        this.$notify({
                            group: 'foo',
                            title: this._('Require approval is checked'),
                            text: this._('Atleast one approver is required'),
                            duration: 4000,
                            position: 'top left',
                            type: 'error'
                        });
                        this.$store.commit('setLoading', false)
                        return false
                    }

                    // here is after all validations
                    if (this.viewedForm) {
                        if (this.isEditingLabels) this.updateFormLabels()
                    } else {
                        let className = ''
                        if (this.getSection == 'survey')
                            className = 'Data_' + this.formEnglishLabel.slugify()
                        else className = 'Meta_' + this.formEnglishLabel.slugify()

                        let q = new Parse.Query('Form')
                        q.equalTo('class_name', className)
                        let result = await q.first()


                        if (!result) {
                            let Form = Parse.Object.extend('Form')
                            let newForm = new Form()

                            let formObject = {
                                layout: this.formFields,
                                label_english: this.formEnglishLabel,
                                label_pashto: this.formPashtoLabel,
                                label_dari: this.formDariLabel,
                                form_languages: this.formLanguages,
                                createdBy: makePointer('User', this.user.id),
                                type: this.getSection,
                                status: 'pending',
                                is_enabled: true,
                                department: this.department,
                                category: this.getCategory
                            }
                            if (this.getSection == 'survey') {
                                formObject['category'] = makePointer('Category', this.getCurrentCategory.id)
                                formObject['survey_submission_approvers'] = this.submissionApprovers.map(user => user.user)
                                formObject['submission_require_approval'] = this.isAssigningSubmissionApprovers
                                formObject['design_require_approval'] = this.isAssigningDesignApprovers
                                formObject['survey_design_approvers'] = this.designApprovers.map(user => user.user)
                                formObject['survey_submitters'] = this.submitters.map(user => user.user)
                                formObject['shared_with'] = this.sharedWith.map(guest => guest.user)
                                formObject['survey_provinces'] = this.getSelectedProvincesObject || []
                                formObject['survey_design_status'] = !this.isAssigningDesignApprovers ? 'approved' : 'pending'
                                formObject['is_meta_form'] = false
                            } else {
                                formObject['survey_design_status'] = 'approved'
                                formObject['submission_require_approval'] = false
                                formObject['design_require_approval'] = false
                                formObject['status'] = 'running'
                                formObject['class_name'] = className
                                formObject['is_meta_form'] = true
                            }

                            newForm.save(formObject).then(async insertedForm => {
                                this.viewedForm = insertedForm

                                var action
                                var myRoute
                                if (this.getSection == 'survey') {
                                    action = 'create';
                                    myRoute = this.$route.path.slice(0, -3) + insertedForm.id
                                }
                                else {
                                    action = 'createMetaForm';
                                    myRoute = this.$route.matched[0].name + '/meta-forms/preview/' + insertedForm.id
                                }


                                await this.g_newActivity({
                                    label_english: insertedForm.get('label_english'),
                                    label_pashto: insertedForm.get('label_pashto'),
                                    label_dari: insertedForm.get('label_dari'),
                                    type: this.getSection,
                                    action: action,
                                    url: myRoute,
                                    to: null,
                                    category: this.getCategory,
                                    department: this.department,
                                    class: 'Form',
                                    reference_id: insertedForm.id
                                })

                                // this is notification
                                if (this.getSection == 'survey') {
                                    this.designApprovers.forEach(async user => {
                                        await this.g_newActivity({
                                            label_english: insertedForm.get('label_english'),
                                            label_pashto: insertedForm.get('label_pashto'),
                                            label_dari: insertedForm.get('label_dari'),
                                            type: 'survey',
                                            action: 'designApprovalAssignment',
                                            url: myRoute,
                                            to: user.user,
                                            category: this.getCategory,
                                            department: this.department,
                                            class: 'Form',
                                            reference_id: insertedForm.id
                                        })
                                    })




                                    this.$notify({
                                        group: 'foo',
                                        text: this._('Survey form was created'),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'success'
                                    });

                                    this.$router.replace('/surveys/' + this.$route.params.scope + '/' + this.$route.params.category + '/form/' + insertedForm.id)
                                } else {
                                    // await this.publishMetaForm(className)
                                    await this.publisher(insertedForm, true)
                                    // this.$router.replace('/' + this.getSection + 's/' + this.$route.params.scope + '/' + this.$route.params.category + '/meta-forms/' + insertedForm.id)
                                }

                                this.$store.commit('setLoading', false)

                            }).catch(async e => {
                                await this.viewedForm.destroy()
                                this.$store.commit('setLoading', false)
                                this.$notify({
                                    group: 'foo',
                                    title: this._('System Error'),
                                    text: this._('An error was encountered while creating ' + this.getSection + ' form'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                        } else {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('A form already exists with the same name'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }
                    }
                }
            },

            checkDuplicateFieldsWithSameDatabaseNames(currentField) {
                var dups = []
                for (const key in this.formFields) {
                    let field = this.formFields[key]
                    if (field.type != 'heading' && field.type != 'description' && field.fieldDatabaseName == currentField.fieldDatabaseName && currentField.name != field.name) {
                        dups.push(field)
                    }
                }
                return dups
            },

            showErrorMessage(message) {
                this.$store.commit('setLoading', false)
                this.$notify({
                    group: 'foo',
                    title: this._('Invalid form design'),
                    text: this._(message),
                    duration: 4000,
                    position: 'top left',
                    type: 'error'
                });
            },

            // async publishMetaForm(className) {
            //     var NewClass = Parse.Object.extend(className);
            //     var newEntry = new NewClass();

            //     let myObject = {}
            //     myObject['category'] = this.getCategory;
            //     myObject['department'] = this.department;
            //     myObject['form'] = this.viewedForm;
            //     this.formFields.forEach(field => {
            //         if (field.type !== 'heading' && field.type !== 'description') {
            //             if (field.type == 'text') {
            //                 if (field.fieldType == 'number') {
            //                     myObject[field.fieldDatabaseName] = 0
            //                 } else {
            //                     myObject[field.fieldDatabaseName] = ''
            //                 }
            //             } else if (field.type == 'textarea' || field.type == 'single-option') {
            //                 myObject[field.fieldDatabaseName] = ''
            //             } else if (field.type == 'checkbox') {
            //                 myObject[field.fieldDatabaseName] = false
            //             } else if (field.type == 'select' || field.type == 'attachment') {
            //                 if (field.multiple)
            //                     myObject[field.fieldDatabaseName] = []
            //                 else myObject[field.fieldDatabaseName] = ''
            //             } else if (field.type == 'date') {
            //                 myObject[field.fieldDatabaseName] = new Date()
            //             } else if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
            //                 myObject[field.fieldDatabaseName] = []
            //             } else if (field.type == 'single-geolocation') {
            //                 myObject['latitude'] = 0;
            //                 myObject['longitude'] = 0;
            //             }
            //         }
            //     })

            //     await newEntry.save(myObject).then(item => item.destroy().then(r => {
            //         this.$notify({
            //             group: 'foo',
            //             text: this._(this.getSection.charAt(0).toUpperCase() + this.getSection.slice(1) + ' form was created'),
            //             duration: 4000,
            //             position: 'top left',
            //             type: 'success'
            //         });
            //     }).catch(e => {
            //         this.viewedForm.destroy()
            //         this.$store.commit('setLoading', false)
            //         this.$notify({
            //             group: 'foo',
            //             title: this._('System Error'),
            //             text: this._("An error accured while creating form"),
            //             duration: 4000,
            //             position: 'top left',
            //             type: 'error'
            //         });
            //     }));
            // },


            async publisher(form, is_meta_form) {
                var NewClass = Parse.Object.extend(form.get('class_name'));
                var newEntry = new NewClass();
                let myObject = {}

                if (is_meta_form) {
                    myObject['category'] = this.getCategory;
                    myObject['department'] = this.department;
                    myObject['form'] = this.viewedForm;
                    myObject['submission_language'] = ''
                }

                if (form && this.formFields) {
                    this.formFields.forEach(field => {
                        if (!field.isPrevious) {
                            if (field.type !== 'heading' && field.type !== 'description') {
                                if (field.type == 'text') {
                                    if (field.fieldType == 'number') {
                                        myObject[field.fieldDatabaseName] = 0
                                    } else {
                                        myObject[field.fieldDatabaseName] = ''
                                    }
                                } else if (field.type == 'textarea' || field.type == 'single-option') {
                                    myObject[field.fieldDatabaseName] = ''
                                } else if (field.type == 'checkbox') {
                                    myObject[field.fieldDatabaseName] = false
                                } else if (field.type == 'select' || field.type == 'attachment') {
                                    if (field.multiple)
                                        myObject[field.fieldDatabaseName] = []
                                    else myObject[field.fieldDatabaseName] = ''
                                } else if (field.type == 'date') {
                                    if (field.isTime) {
                                        myObject[field.fieldDatabaseName] = 0
                                    } else {
                                        myObject[field.fieldDatabaseName] = new Date()
                                    }
                                } else if (field.type == 'multiple-option' || field.type == 'multiple-geolocation') {
                                    myObject[field.fieldDatabaseName] = []
                                } else if (field.type == 'single-geolocation') {
                                    myObject['latitude'] = 0;
                                    myObject['longitude'] = 0;
                                }
                            }
                        } else {
                        }
                    })


                    await newEntry.save(myObject).then(item => item.destroy().then(r => {
                        var temp = this.formFields.map(field => {
                            return { ...field, isPrevious: true }
                        })
                        this.viewedFormLayout = []
                        this.viewedFormLayout = [...temp]
                        this.formFields = []
                        this.formFields = [...temp]

                        if (is_meta_form) {
                            this.$notify({
                                group: 'foo',
                                text: this._(this.getSection.charAt(0).toUpperCase() + this.getSection.slice(1) + ' form was created'),
                                duration: 4000,
                                position: 'top left',
                                type: 'success'
                            });
                            this.$router.replace('/' + this.getSection + 's/' + this.$route.params.scope + '/' + this.$route.params.category + '/meta-forms/' + form.id)
                        }
                    }).catch(e => {
                        if (is_meta_form) {
                            this.viewedForm.destroy()
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                title: this._('System Error'),
                                text: this._("An error accured while creating form"),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }
                    }));
                }
            },

            async fetchProvinces() {
                let q = new Parse.Query('Province')
                let result = await q.find()
                this.allProvinces = result
                this.setAllProvincesToState(this.allProvinces)
                this.provinces_english = result.map(l => {
                    return {
                        label: l.get('label_english'),
                        value: l.id,
                    }
                })


                this.provinces_pashto = result.map(l => {
                    return {
                        label: l.get('label_pashto'),
                        value: l.id,
                    }
                })


            },

            async fetchings() {
                this.$store.commit('setLoading', true)

                // determine the section (survey, article, file, map)
                this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)

                // 2. setting category and department
                this.category = this.getCurrentCategory
                this.department = this.getCurrentDepartment

                if (this.getSection == 'survey') {
                    if (this.getAllProvincesFromState && this.getAllProvincesFromState.length > 0) {
                        this.allProvinces = this.getAllProvincesFromState
                        var temp_english = []
                        var temp_pashto = []
                        temp_english = this.allProvinces.map(l => {
                            return {
                                label: l.get('label_english'),
                                value: l.id,
                            }
                        })

                        this.provinces_english = temp_english


                        temp_pashto = this.allProvinces.map(l => {
                            return {
                                label: l.get('label_pashto'),
                                value: l.id,
                            }
                        })

                        this.provinces_pashto = temp_pashto


                    } else {
                        await this.fetchProvinces()
                    }
                }

                // editing survey form (pending or not pending)
                if (this.$route.params.id && this.$route.params.id != 'new') {
                    // this.viewedForm = await this.g_fetchObject(this.$route.params.id, 'Form')
                    var q = new Parse.Query("Form")
                    q.equalTo('objectId', this.$route.params.id)
                    if (this.getSection == 'survey') {
                        q.include('survey_submitters')
                        q.include('survey_submission_approvers')
                        q.include('survey_design_approvers')
                        q.include('shared_with')
                    }
                    this.viewedForm = await q.first()
                    this.setCurrentFormToState(this.viewedForm)
                    this.viewedFormLayout = this.viewedForm.get('layout')
                    this.formLanguages = this.viewedForm.get('form_languages')
                    this.formEnglishLabel = this.viewedForm.get('label_english')
                    this.formPashtoLabel = this.viewedForm.get('label_pashto')
                    this.formDariLabel = this.viewedForm.get('label_dari')


                    if (this.getSection == 'survey') {

                        // set survey provinces
                        var temp_provinces = []
                        if (this.viewedForm.get('survey_provinces')) {
                            this.viewedForm.get('survey_provinces').forEach(province => {
                                temp_provinces.push(province.id)
                            })
                        }
                        this.selectedProvinces = []
                        this.selectedProvinces = [...temp_provinces]

                        if (this.viewedForm.get('survey_submission_approvers').length != 0) this.isAssigningSubmissionApprovers = true
                        if (this.viewedForm.get('survey_design_approvers').length != 0) this.isAssigningDesignApprovers = true

                        // fetching saved submitters
                        // if (this.viewedForm.get('survey_submitters')) {
                        //     for (const key in this.viewedForm.get('survey_submitters')) {
                        //         this.viewedForm.get('survey_submitters')[key].fetch()
                        //     }
                        // }

                        // // fetching saved submission approvers
                        // if (this.viewedForm.get('survey_submission_approvers')) {
                        //     for (const key in this.viewedForm.get('survey_submission_approvers')) {
                        //         this.viewedForm.get('survey_submission_approvers')[key].fetch()
                        //     }
                        // }

                        // // fetching saved survey design approvers
                        // if (this.viewedForm.get('survey_design_approvers')) {
                        //     for (const key in this.viewedForm.get('survey_design_approvers')) {
                        //         this.viewedForm.get('survey_design_approvers')[key].fetch()
                        //     }
                        // }



                        // settings survey submitters
                        let temp_submitters = []
                        if (this.viewedForm.get('survey_submitters')) {
                            for (const key in this.viewedForm.get('survey_submitters')) {
                                let user = this.viewedForm.get('survey_submitters')[key]
                                // temp_submitters.push({ user: user, isPrev: true, hasSubmission: this.viewedForm.get('status') == 'pending' ? false : await this.g_userHasSubmission(this.viewedForm, user) })
                                temp_submitters.push({ user: user, isPrev: true })
                            }
                            this.submitters = temp_submitters
                        }


                        // settings survey submission approvers
                        if (this.viewedForm.get('survey_submission_approvers')) {
                            this.submissionApprovers = this.viewedForm.get('survey_submission_approvers').map(user => {
                                // return { user: user, isPrev: true, hasSubmission: this.viewedForm.get('status') == 'completed' ? true : false }
                                return { user: user, isPrev: true }
                            })
                        }

                        // settings survey design approvers
                        if (this.viewedForm.get('survey_design_approvers')) {
                            this.designApprovers = this.viewedForm.get('survey_design_approvers').map(user => {
                                // return { user: user, isPrev: true, hasSubmission: this.viewedForm.get('status') == 'pending' ? false : true }
                                return { user: user, isPrev: true }
                            })
                        }

                        // settings survey shared_with users
                        if (this.viewedForm.get('shared_with')) {
                            this.sharedWith = this.viewedForm.get('shared_with').map(guest => {
                                // return { user: guest, isPrev: true, hasSubmission: this.viewedForm.get('status') == 'pending' ? false : true }
                                return { user: guest, isPrev: true }
                            })
                        }
                    }

                }
                this.$store.commit('setLoading', false)
            }
        },



        async mounted() {
            if (this.getScreenWidth > 425) {
                await this.fetchings()
            }
        }
    }

</script>

<style>

</style>